import React from 'react';
import { CheckIcon, CreditCardIcon } from 'lucide-react';
import { ORIGINAL_PRICE, PRICE, copy, offerIncludes, offerRows } from '../data/soklar';
import { PRODUCT_IMAGE } from '../data/soklarMedia';
import { CtaButton } from './CtaButton';
import { ProductBoxPlaceholder } from './SoPlaceholders';
export function Offer() {
  const t = copy.offer;
  return <section id="offer" className="w-full bg-slate-900 px-5 py-24 text-stone-50 sm:px-14 sm:py-32" data-id="element-220" data-mp="1hqinr4uc0goe">
      <div className="mx-auto grid max-w-6xl gap-14 lg:grid-cols-12 lg:items-center" data-id="element-221" data-mp="u0xv1u8dm51x">
        <div className="px-3 sm:px-0 lg:col-span-6" data-id="element-222" data-mp="p1l5h1q4ejvn">
          <h2 className="font-serif text-[2.6rem] leading-[1.02] tracking-tight sm:text-6xl" data-id="element-223" data-mp="13xkf4gsvos2w">
            {t.titleStart} <em className="text-red-300" data-id="element-224" data-mp="ywwnbswts77m">{t.brand}</em>{t.titleEnd}
          </h2>
          <p className="mt-6 max-w-md text-lg leading-relaxed text-stone-50/70" data-id="element-225" data-mp="2fbogi81spihz">
            {t.text}
          </p>
          {PRODUCT_IMAGE ? <img src={PRODUCT_IMAGE} alt="" className="mx-auto mt-12 hidden w-full max-w-sm drop-shadow-2xl lg:block" data-id="element-226" data-mp="2acbjwvl4gx27" /> : <div className="mt-12 hidden lg:block" data-id="element-227" data-mp="pjp8ru1dymmr"><ProductBoxPlaceholder data-id="element-228" data-mp="ujbn66sya8x5" /></div>}
        </div>

        <div id="offer-card" className="scroll-mt-16 rounded-3xl bg-stone-50 p-6 text-slate-900 shadow-2xl shadow-black/40 sm:p-11 lg:col-span-6" data-id="element-229" data-mp="uhqrueytaly8">
          <p className="text-sm font-semibold text-slate-900/60" data-id="element-230" data-mp="13jqbzg54i65e">{t.includesLabel}</p>

          <ul className="mt-5 divide-y divide-slate-900/10 border-y border-slate-900/10" data-id="element-231" data-mp="6tppxow523rs">
            {offerRows.map(row => <li key={row.label} className="flex gap-4 py-4" data-id="element-232" data-mp="bskhbf8690ni">
                <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-red-700" data-id="element-233" data-mp="bt2f4gahfmxj">
                  <CheckIcon className="h-3 w-3 text-white" strokeWidth={3} aria-hidden="true" data-id="element-234" data-mp="fskuyxng57ti" />
                </span>
                <span data-id="element-235" data-mp="3k8vpsei4u46o">
                  <span className="block font-medium leading-snug" data-id="element-236" data-mp="3k7kpwprt5gku">{row.label}</span>
                  <span className="mt-0.5 block text-sm leading-snug text-slate-900/65" data-id="element-237" data-mp="3o9pjjoi9ad7h">{row.detail}</span>
                </span>
              </li>)}
          </ul>

          <div className="mt-8 flex flex-col items-center gap-2 text-center sm:flex-row sm:items-end sm:justify-between sm:gap-4 sm:text-left" data-id="element-238" data-mp="vde5qybdbq2h">
            <div className="sm:pb-2" data-id="element-239" data-mp="155tohxuhoiof">
              <p className="text-sm text-slate-900/60" data-id="element-240" data-mp="154qvnkdlw65v">
                {t.originalLabel} <s data-id="element-241" data-mp="107s5fcx2cjcy">{ORIGINAL_PRICE}</s>
              </p>
              <p className="text-sm font-medium text-slate-900/70" data-id="element-242" data-mp="cgmpyyv1bt36">{t.priceLabel}</p>
            </div>
            <p className="font-serif text-7xl leading-none tracking-tight text-slate-900 sm:text-8xl" data-id="element-243" data-mp="7i1nessb8xbk">
              {PRICE}
            </p>
          </div>
          <p className="mt-3 flex items-center justify-center gap-2 text-sm text-slate-900/70 sm:justify-end" data-id="element-244" data-mp="livzpmihbifi">
            <CreditCardIcon className="h-4 w-4" aria-hidden="true" data-id="element-245" data-mp="hi2bes14k1m3" />
            {t.oneTime}
          </p>

          <CtaButton label={t.cta} className="mt-8 w-full" data-id="element-246" data-mp="1wykngg3k4lhd" />

          <ul className="mt-5 flex flex-wrap justify-center gap-x-4 gap-y-1 text-xs text-slate-900/60" data-id="element-247" data-mp="1sucx6ehgaxh1">
            {offerIncludes.map(item => <li key={item} data-id="element-248" data-mp="20gqijr9nyw7b">{item}</li>)}
          </ul>
        </div>
      </div>
    </section>;
}